import {AutoplayHandlerModule} from '@fantasmagames/slot/src/modules/autoplay/AutoplayHandlerModule';

import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';

export class AutoplayFreeSpinsState extends ModuleState<null, AutoplayHandlerModule> {
	public onEnterState(): void {}

	public onLeaveState(): void {}

	protected setupEvents(): void {}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/autoplay/states/AutoplayFreeSpinsState.ts